import { queryClient } from '@m43/core';
import { useEnabledFeatures } from '../../../common/hooks/enabled-features/use-enabled-features';
import { errorOccurredWhile } from '../../../common/helpers/error-occurred-while';
import { useToast } from '@cad-arc';
import { ConversationView } from '@mark43/cad-api';
import { getParticipantUnreadUrgencies, playNewMessageAlert } from '../../helpers/sound-helpers';
import { MessagingStore } from '../../store/messaging-store';
import { useMessagingResource } from './use-messaging-resource';
import { useApplicationType } from '../../../common/hooks/use-application-type';

export const useConversationQuery = (store: MessagingStore) => {
    const { getConversation } = useMessagingResource();
    const enabledFeatures = useEnabledFeatures();
    const toast = useToast();
    const { isCad } = useApplicationType();

    const fetchConversation = async (
        conversationId: number,
        conversationInitiatorUserId: number
    ) => {
        try {
            const conversationView = await queryClient.fetchQuery<ConversationView | null>(
                ['conversation', conversationId],
                () => {
                    return getConversation(conversationId);
                }
            );
            if (conversationView === null) {
                return;
            }
            store.addConversation(conversationView);

            const userId = store?.participantIdentities?.activeMappedByType.USER.id;

            if (userId !== undefined && conversationInitiatorUserId !== userId) {
                const participant = conversationView.assignedParticipantUnreadInfos.find(
                    ({ participantId }) => participantId === userId
                );

                if (participant) {
                    playNewMessageAlert(getParticipantUnreadUrgencies(participant), {
                        enabledFeatures,
                        isCad,
                    });
                }
            }
        } catch (error) {
            toast({
                status: 'error',
                description: errorOccurredWhile('retrieving a conversation'),
                id: `retrieve-conversation`,
            });
        }
    };

    return { fetchConversation };
};
